import React from "react";
import "../style/Loading.css";
// import LoadingGif from '../images/ui/Paw_V2.gif'
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SmallerLoading = () => {
  return (
    <div className={`loading-component`}>
      <div className="small-spinner">
        <FontAwesomeIcon icon={faSpinner} color="black" spinPulse size="2xl"/>
        {/* <img src={LoadingGif} alt="loading..."/> */}
      </div>
    </div>
  );
};

export default SmallerLoading;
